import { CustomerInfoKeyType } from 'types/customer';
import { printf } from 'utils/i18n';

interface OptionItem {
    value: string;
    label: string;
}

interface MarscoOptionItem extends OptionItem {
    level: number;
}

export const defaultFieldsOfAssetsInfo: CustomerInfoKeyType[] = [
    'net_assets',
    'net_current_assets',
    'net_year_income',
    'stk_kl'
];

/* --------------- 流动净资产net_current_assets的配置项 --------------- */
export const netCurAssetsOptions: MarscoOptionItem[] = [
    { value: '20', label: __('Under $25,000'), level: 1 },
    { value: '21', label: '$25,001-$100,000', level: 2 },
    { value: '22', label: '$100,001-$250,000', level: 3 },
    { value: '23', label: '$250,001-$500,000', level: 4 },
    { value: '24', label: '$500,001-$1,000,000', level: 5 },
    { value: '25', label: '$1,000,001-$2,000,000', level: 6 },
    { value: '26', label: '$2,000,001-$3,000,000', level: 7 },
    { value: '27', label: '$3,000,001-$4,000,000', level: 8 },
    { value: '28', label: '$4,000,001-$5,000,000', level: 9 },
    { value: '29', label: '$5,000,001-$7,500,000', level: 10 },
    { value: '30', label: printf(__('Over %s'), '$7,500,000'), level: 11 }
];

/* --------------- 净资产net_assets的配置项 --------------- */
export const netAssetsOptions: MarscoOptionItem[] = [
    { value: '20', label: __('Under $25,000'), level: 1 },
    { value: '21', label: '$25,001-$100,000', level: 2 },
    { value: '22', label: '$100,001-$250,000', level: 3 },
    { value: '23', label: '$250,001-$500,000', level: 4 },
    { value: '24', label: '$500,001-$1,000,000', level: 5 },
    { value: '25', label: '$1,000,001-$2,000,000', level: 6 },
    { value: '26', label: '$2,000,001-$3,000,000', level: 7 },
    { value: '27', label: '$3,000,001-$4,000,000', level: 8 },
    { value: '28', label: '$4,000,001-$5,000,000', level: 9 },
    { value: '29', label: '$5,000,001-$7,500,000', level: 10 },
    { value: '30', label: '$7,500,001-$10,000,000', level: 11 },
    { value: '31', label: '$10,000,001-$50,000,000', level: 12 },
    { value: '32', label: printf(__('Over %s'), '$50,000,000'), level: 13 }
];

/* --------------- 年净收入net_year_income的配置项 --------------- */
export const netYearIncomeOptions: OptionItem[] = [
    { value: '20', label: __('Under $25,000') },
    { value: '21', label: '$25,001-$50,000' },
    { value: '22', label: '$50,001-$100,000' },
    { value: '23', label: '$100,001-$250,000' },
    { value: '24', label: '$250,001-$500,000' },
    { value: '25', label: '$500,001-$1,000,000' },
    { value: '26', label: '$1,000,001-$2,500,000' },
    { value: '27', label: '$2,500,001-$5,000,000' },
    { value: '28', label: '$5,000,001-$7,500,000' },
    { value: '29', label: '$7,500,001-$10,000,000' },
    { value: '30', label: printf(__('Over %s'), '$10,000,000') }
];

/* --------------- stk_kl配置项 --------------- */
export const stkKlOptions: OptionItem[] = [
    { value: '0', label: __('Limited (Less than a year)') },
    { value: '1', label: __('Good (Less than 5 years)') },
    { value: '2', label: __('Excellent (More than 5 years)') }
];
